import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { CreateUserPayload, UpdateUserPayload, UserListItem } from '../types/user';

export interface ListUsersParams {
  page: number;
  pageSize: number;
  search?: string;
  roleId?: number;
  branchId?: number;
  isActive?: boolean;
}

export const listUsers = async (
  params: ListUsersParams,
): Promise<PaginatedResponse<UserListItem>> => {
  const { data } = await apiClient.get('/users', { params });
  return data;
};

export const createUser = async (payload: CreateUserPayload): Promise<UserListItem> => {
  const { data } = await apiClient.post('/users', payload);
  return data.data;
};

export const updateUser = async (id: number, payload: UpdateUserPayload): Promise<UserListItem> => {
  const { data } = await apiClient.patch(`/users/${id}`, payload);
  return data.data;
};

export const setUserActive = async (id: number, isActive: boolean): Promise<UserListItem> => {
  const { data } = await apiClient.post(`/users/${id}/${isActive ? 'activate' : 'deactivate'}`);
  return data.data;
};

export type ResetUserPasswordPayload =
  | { newPassword: string; generateTemporary?: never }
  | { generateTemporary: true; newPassword?: never };

export const resetUserPassword = async (
  id: number,
  payload: ResetUserPasswordPayload,
): Promise<{ temporaryPassword?: string } | null> => {
  const { data } = await apiClient.post(`/users/${id}/reset-password`, payload);
  return data.data;
};
